import React, { useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const defaultModules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    ['link'],
    ['clean'],
  ],
};

const emptyModules = { toolbar: false };

/**
 * Converte texto legado (sem tags) em HTML mínimo para o Quill.
 */
export function ensureRichTextValue(value) {
  if (value == null || value === '') return '';
  const s = String(value);
  if (/<[a-z][\s\S]*>/i.test(s)) return s;
  if (!s.trim()) return '';
  return s
    .split('\n')
    .map((line) => {
      const escaped = line
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
      return `<p>${escaped || '<br />'}</p>`;
    })
    .join('');
}

export function isEmptyRichText(html) {
  return !stripHtml(html || '');
}

/**
 * Editor WYSIWYG (HTML) — descrições, observações e textos longos.
 */
export function RichTextEditor({
  value,
  onChange,
  placeholder,
  className = '',
  readOnly = false,
  minHeight,
  variant = 'default',
}) {
  const modules = useMemo(() => (readOnly ? emptyModules : defaultModules), [readOnly]);

  const sizeClass = variant === 'compact' ? 'rich-text-editor--compact' : '';
  const style = minHeight ? { minHeight } : undefined;

  return (
    <div
      className={`rich-text-editor ${sizeClass} ${className}`.trim().replace(/\s+/g, ' ')}
    >
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={onChange}
        modules={modules}
        readOnly={readOnly}
        placeholder={placeholder}
        style={style}
      />
    </div>
  );
}

/**
 * Exibe HTML gerado pelo Quill com tipografia alinhada ao editor.
 */
export function RichTextHtml({ html, className = '' }) {
  if (!html || !String(html).trim()) return null;
  return (
    <div className={`rich-text-html ql-snow ${className}`.trim()}>
      <div className="ql-editor" dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}

/** Prévia em listagens (remove tags). */
export function stripHtml(html) {
  if (!html || typeof html !== 'string') return '';
  return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
}
